var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.963 0.744L8.707 4L11.9625 7.2555C11.9845 7.1735 12 7.089 12 7V1C12 0.911 11.9845 0.8265 11.963 0.744ZM7.344 3.9495L11.256 0.0369997C11.1735 0.0154997 11.089 0 11 0H1C0.911 0 0.8265 0.0154997 0.744 0.0369997L4.656 3.9495C5.3975 4.69 6.6025 4.69 7.344 3.9495ZM6 5.5045C5.28 5.5045 4.5635 5.2335 4.005 4.702L0.744 7.963C0.8265 7.9845 0.911 8 1 8H11C11.089 8 11.1735 7.9845 11.256 7.963L7.995 4.702C7.4365 5.2335 6.72 5.5045 6 5.5045ZM0.0370002 0.744C0.0155002 0.8265 0 0.911 0 1V7C0 7.089 0.0155002 7.1735 0.0370002 7.256L3.293 4L0.0370002 0.744Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.f9cc877e2617bf65ebc73ec3462b01d5.svg";
export { ForwardRef as ReactComponent };